import React from 'react';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CloseButton } from '@components/Alert/CloseButton';
import { AuthHeader } from './components/AuthHeader';
import coverPhoto from '../../images/updated-collage.png';
import logo from './img/logo-laguna.png';
import 'react-toastify/dist/ReactToastify.css';
import './styles.scss';

export const AuthLayout = () => (
  <>
    <ToastContainer className="toasts" closeButton={CloseButton} />
    <main className="auth">
      <div className="auth-inner">
        <aside className="auth-banner">
          <div className="auth-banner-inner">
            <div className="auth-banner-logo">
              <img src={logo} alt="Laguna Clinical Research Associates" />
            </div>
            <div className="auth-banner-collage">
              <img src={coverPhoto} alt="Laguna team collage" />
            </div>
            <p className="auth-banner-quote">Honoring Diversity with New Horizons | New Medicine</p>
          </div>
        </aside>
        <div className="auth-content">
          <AuthHeader />
          <Outlet />
        </div>
      </div>
    </main>
  </>
);
